import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';

@Component({
  selector: 'state-lov',
  templateUrl: './state-lov.component.html',
  styleUrls: ['./state-lov.component.css']
})
export class StateLovComponent {

  stateModuleId: string = 'BMM145';
  private selectedData: any;
  public titleLov: string = "STATE";

  stateTable: any = {
    cols: [
      {
        key: "stateCd",
        header: "State Code",
        dataType: "string",
        width: '30%'
      },
      {
        key: "stateLongDesc",
        header: "State",
        dataType: "string"
      },
      {
        key: "bmCode",
        header: "BM Code",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<StateLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) { 
    this.getStateData();
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);
      
    }
  }

  private getStateData(): void {
    try {
      this.stateTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getStates({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV",
        regionCd:  this.fromMainData.regionCd
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, ()=>{
              let content = JSON.parse(this.jsonDataService.decrypt(data.response));
              if (content.moduleId === this.stateModuleId) {
                this.jsonDataService.contorlLoading(false);
                this.stateTable.tblData = content.data.filter((d: any) => (d.activeTag === 'A'));
                this.stateTable.loading = false;
              } else {
                this.stateTable.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {
            
            this.stateTable.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);
      
      this.stateTable.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);
      
    }
  }

}
